import { Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { HelperService } from '@app/shared/services/helper.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { toSignal } from '@angular/core/rxjs-interop';
import { TrophiesService } from '../trophies.service';
import { SharedModule } from '@app/shared/shared.module';
import { GameTierComponent } from '@app/shared/components/game-tier/game-tier.component';
import { TrophyComponent } from './trophy/trophy.component';

@Component({
  selector: 'slotcom-game-trophies-modal',
  standalone: true,
  templateUrl: './game-trophies-modal.component.html',
  styleUrl: './game-trophies-modal.component.scss',
  imports: [SharedModule, GameTierComponent, TrophyComponent],
})
export class GameTrophiesModalComponent {
  helper = inject(HelperService);
  private assetsService = inject(AssetsService);
  logger = inject(LoggerService);
  private gamesRepo = inject(GamesRepository);
  private eventManager = inject(EventManager);
  achievementModalData = inject<Modal>(MAT_DIALOG_DATA);
  private trophiesService = inject(TrophiesService);

  private gamesrepo = toSignal(this.gamesRepo.allGames$, { initialValue: [] });

  gameId = computed(() => this.achievementModalData.data().gameId);

  gameIcon = computed(() => this.assetsService.getGameIconUrl(this.gameId()));

  game = computed(() => this.gamesrepo().find((g) => g.gameId === this.gameId()));

  trophy = computed(() => this.game()?.trophy);

  trophiesList = computed(() => (this.trophy() ? this.trophiesService.getTrophyListByTier(this.trophy().tier) : []));

  currentTrophyIndex = computed(() => (this.trophy() ? this.trophiesList().indexOf(this.trophy().trophy) : -1));

  gameTier = computed(() => this.trophy()?.tier);

  closeModal() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.GameTrophiesModalComponent, ModalType.View));
  }
  openInfo() {
    this.eventManager.openModal(new Modal(NonPersistedModalName.InfoGameTrophiesModalComponent, ModalType.View));
  }
}
